  import React, { useState, useEffect, useCallback } from 'react';
  import { Customers, FollowUps as API } from '../services/api';

  const todayStr = () => new Date().toISOString().slice(0, 10);

  export default function FollowUps() {
    const [busy, setBusy] = useState(true);
    const [err, setErr]   = useState('');
    const [tab, setTab]   = useState('today'); // 'today' | 'overdue'
    const [rows, setRows] = useState([]);

    const load = useCallback(() => {
      setBusy(true); setErr('');
      Customers.list()
        .then(list => {
          const pending = list
            .filter(c => c.next_followup_date)
            .sort((a, b) => a.next_followup_date.localeCompare(b.next_followup_date));
          setRows(pending);
        })
        .catch(ex => setErr(ex.message || 'Failed to load follow-ups'))
        .finally(() => setBusy(false));
    }, []);
    useEffect(load, [load]);

    const today = todayStr();
    const todayRows   = rows.filter(r => r.next_followup_date === today);
    const overdueRows = rows.filter(r => r.next_followup_date < today);
    const activeRows  = tab === 'today' ? todayRows : overdueRows;

    const markDone = async (customerId) => {
      try { await API.markDone(customerId); load(); }
      catch (ex) { alert(ex.messagxe); }
    };

    return (
      <div className="page">
        <div className="page-header">
          <div className="page-title">📅 Follow-ups</div>
        </div>

        {err && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{err}</div>}

        <div className="tabs" style={{ marginBottom: '1.2rem' }}>
          <button className={`tab${tab === 'today' ? ' active' : ''}`} onClick={() => setTab('today')}>
            Today <span style={{ opacity: .6, fontSize: '.72rem' }}>({todayRows.length})</span>
          </button>
          <button className={`tab${tab === 'overdue' ? ' active' : ''}`} onClick={() => setTab('overdue')}>
            Delayed <span style={{ opacity: .6, fontSize: '.72rem', color: overdueRows.length ? 'var(--red)' : undefined }}>({overdueRows.length})</span>
          </button>
        </div>

        {busy ? <div className="spinner-wrap"><div className="spinner" /></div> :
          activeRows.length === 0 ? (
            <div className="empty">
              {tab === 'today' ? 'No follow-ups due today 🎉' : 'No overdue follow-ups 🎉'}
            </div>
          ) : (
            activeRows.map(c => {
              const daysOverdue = tab === 'overdue'
                ? Math.floor((new Date(today) - new Date(c.next_followup_date)) / 86400000)
                : null;
              return (
                <div key={c.id} className="list-row" style={{ marginBottom: '.5rem' }}>
                  <div className="row-main">
                    <div className="row-title">{c.company}</div>
                    <div className="row-sub">
                      {c.followup_note || '—'}
                      {daysOverdue !== null && (
                        <span style={{ color: 'var(--red)', marginLeft: 6 }}>
                          · {daysOverdue}d overdue (was {c.next_followup_date})
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row-actions">
                    <span className="badge" style={{
                      background: c.followup_source === 'call' ? 'var(--accent)' : 'var(--purple)',
                      color: '#0f172a', fontSize: '.72rem',
                    }}>
                      {c.followup_source === 'call' ? '📞 Call' : '📍 Visit'}
                    </span>
                    <button className="btn btn-sm btn-success" onClick={() => markDone(c.id)}>✓ Mark Done</button>
                  </div>
                </div>
              );
            })
          )
        }
      </div>
    );
  }
